import {deserialize, serialize, inheritSerialization, deserializeAs} from "cerialize";

import BaseUUIDEntity from "./BaseUUIDEntity";
import Biaya from "./Biaya";
import Persyaratan from "./Persyaratan";
import Seragam from "./Seragam";

@inheritSerialization(BaseUUIDEntity)
export default class ProsesPendaftar extends BaseUUIDEntity {

    @serialize
    @deserialize
    public nomor: string = "";

    @serialize
    @deserialize
    public username: string = "";

    @serialize
    @deserialize
    public nomor_transaksi: string = "";

    @serialize
    @deserialize
    public nama_lengkap: string = "";

    @serialize
    @deserialize
    public tempat_tgl_lahir: string = "";

    @serialize
    @deserialize
    public tahun: string = "";

    @serialize
    @deserialize
    public wilayah: string = "";

    @serialize
    @deserialize
    public pendidikan_formal: string = "";

    @serialize
    @deserialize
    public pendidikan_non_formal: string = "";

    @serialize
    @deserialize
    public virtual_account: string = "";

    @serialize
    @deserialize
    public status_pembayaran: string = "";

    @serialize
    @deserialize
    public status_formulir: string = "";

    @serialize
    @deserialize
    public orang_tua: string = "";

    @serialize
    @deserialize
    public desa: string = "";

    @serialize
    @deserialize
    public kecamatan: string = "";

    @serialize
    @deserialize
    public kabupaten: string = "";

    @serialize
    @deserialize
    public nominal_formal: number = 0;

    @serialize
    @deserialize
    public nominal_non_formal: number = 0;

    @serialize
    @deserialize
    public potongan_infaq: number = 0;

    @serialize
    @deserialize
    public biaya_formal: Array<Biaya> = [];

    @serialize
    @deserialize
    public biaya_non_formal: Array<Biaya> = [];

    @serialize
    @deserializeAs(Persyaratan)
    public persyaratan_formal: Array<Persyaratan> = [];

    @serialize
    @deserializeAs(Persyaratan)
    public persyaratan_non_formal: Array<Persyaratan> = [];

    @serialize
    @deserializeAs(Seragam)
    public seragam_formal: Array<Seragam> = [];

    @serialize
    @deserializeAs(Seragam)
    public seragam_non_formal: Array<Seragam> = [];

}
